import PropTypes from 'prop-types';
import React, { useState } from 'react';

import helpIcon from '@coursera/assets/icons/help.svg';
import handIcon from '@coursera/assets/icons/swipe.svg';

import { CircleModal } from '../index';

import styles from './image-viewer.module.scss';

function ImageViewer({ image, imageText }) {
  const [modalOpen, setModalOpen] = useState(true);

  return (
    <div className={styles.viewer}>
      <img src={image} alt={imageText} className={styles.image} />

      <CircleModal
        open={modalOpen}
        appElementId="root"
        secondaryCloseModal={() => setModalOpen(false)}
        secondaryCtaText="Close"
        icon={helpIcon}
        requestClose={() => setModalOpen(false)}
        swipeToClose={true}
      >
        <div>
          <h6>
            Swipe to view
            <br />
            chart
          </h6>
          <img src={handIcon} alt="icon" className={styles.icon} />
        </div>
      </CircleModal>
    </div>
  );
}

ImageViewer.propTypes = {
  image: PropTypes.string,
  imageText: PropTypes.string,
};

export default ImageViewer;
